import { consoleEvents, LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import actions from './actions'
import initialState from './initialState'
import PointsHistoryState, { NormalizedPointsHistory, PointsOverviewSectionOrders } from './types'

const fetchPointsHistoryStart = (state: PointsHistoryState): PointsHistoryState => ({
  ...state,
  loadingPointsHistoryStatus: LoadingStates.Loading,
})

const fetchPointsHistoryFail = (state: PointsHistoryState): PointsHistoryState => {
  consoleEvents.error('Failed to fetch Points History')

  return {
    ...state,
    loadingPointsHistoryStatus: LoadingStates.LoadedFail,
  }
}

const fetchPointsHistorySuccess = (
  state: PointsHistoryState,
  pointsHistory: NormalizedPointsHistory,
): PointsHistoryState => {
  return {
    ...state,
    ...pointsHistory,
    loadingPointsHistoryStatus: LoadingStates.LoadedSuccess,
  }
}

const fetchOrderOfPointsStart = (state: PointsHistoryState): PointsHistoryState => ({
  ...state,
  loadingOrderStatus: LoadingStates.Loading,
})

const fetchOrderOfPointsSuccess = (
  state: PointsHistoryState,
  pointsOverviewSectionOrders: PointsOverviewSectionOrders,
): PointsHistoryState => ({
  ...state,
  pointsOverviewSectionOrders,
  loadingOrderStatus: LoadingStates.LoadedSuccess,
})

const fetchOrderOfPointsFail = (state: PointsHistoryState): PointsHistoryState => ({
  ...state,
  loadingOrderStatus: LoadingStates.LoadedFail,
})

const reducer = createReducer<PointsHistoryState>((on) => {
  on(actions.fetchPointsHistoryStart, fetchPointsHistoryStart)
  on(actions.fetchPointsHistorySuccess, fetchPointsHistorySuccess)
  on(actions.fetchPointsHistoryFail, fetchPointsHistoryFail)
  on(actions.fetchOrderOfPointsStart, fetchOrderOfPointsStart)
  on(actions.fetchOrderOfPointsSuccess, fetchOrderOfPointsSuccess)
  on(actions.fetchOrderOfPointsFail, fetchOrderOfPointsFail)
}, initialState)

export default reducer
